import { IModalHook } from './interfaces';
import { useModal } from './useModal';
import { useModalAnimation } from './useModalAnimation';

export const useSidePage = (Modal: any, hookOptions?: any): IModalHook => {
  const { enterAnimation, leaveAnimation } = useModalAnimation();
  const [handleOpen, handleClose] = useModal(Modal, hookOptions, {
    enterAnimation,
    leaveAnimation,
  });

  return [handleOpen, handleClose];
};
